import { memo, useState } from 'react';
import { Dropdown, Tooltip, Typography } from 'antd';
import { dateToString } from '@/utils';
import { useGetParentFosterCareHasLicenseQuery, useGetParentFosterCareQuery } from '@/services/parent-api';
import { EditSvg, EllipsisVSvg, PlusSvg, SimCardSvg, TrashSvg } from '@/assets/icons';
import Panel from '@/components/panel';
import Button from '@/components/button';
import { ProfileCol, ProfileRow } from '@/components/profile-grid';
import RemoveModal from './remove-modal';
import EditModal from './edit-modal';

const FosterCareLicense = ({ parentId, permissions, setShouldRefetch }) => {
  const { data, isLoading, refetch } = useGetParentFosterCareQuery({ parentId });
  const {
    data: hasLicense,
    refetch: refetchHasLicense,
    isLoading: loading1,
  } = useGetParentFosterCareHasLicenseQuery({ parentId });
  const [isEditModalOpen, openEditModal] = useState(false);
  const [isRemoveModalOpen, openRemoveModal] = useState(false);

  return (
    <Panel
      icon={<SimCardSvg />}
      title="Foster Care License"
      extra={
        permissions.adminStaffAndSuper &&
        data &&
        (hasLicense ? (
          <Dropdown
            menu={{
              items: [
                {
                  key: 'edit',
                  icon: <EditSvg />,
                  label: 'Edit License',
                  onClick: () => openEditModal(true),
                },
                {
                  key: 'remove',
                  danger: true,
                  icon: <TrashSvg />,
                  label: 'Remove License',
                  onClick: () => openRemoveModal(true),
                },
              ].filter((item) => item),
            }}
          >
            <Button type="link" icon={<EllipsisVSvg fontSize="16" />} />
          </Dropdown>
        ) : permissions.adminStaffAndSuper && (
          <Tooltip title="Add License">
            <Button type="link" icon={<PlusSvg fontSize="16" />} onClick={() => openEditModal(true)} />
          </Tooltip>
        ))
      }
      loading={isLoading || loading1}
    >
      {data &&
        (hasLicense ? (
          <ProfileRow>
            <ProfileCol md={12} lg={8} label="Type" value={data.type.name} />
            <ProfileCol md={12} lg={8} label="Effective" value={dateToString(data.effective)} />
            <ProfileCol md={12} lg={8} label="Expires" value={dateToString(data.expires)} />
          </ProfileRow>
        ) : (
          <Typography.Text type="secondary" style={{ display: 'block', textAlign: 'center' }}>
            No Current License
          </Typography.Text>
        ))}

      <EditModal
        parentId={parentId}
        data={data}
        open={isEditModalOpen}
        refetch={refetch}
        refetchHasLicense={refetchHasLicense}
        setShouldRefetch={setShouldRefetch}
        onClose={() => openEditModal(false)}
      />

      <RemoveModal
        parentId={parentId}
        open={isRemoveModalOpen}
        refetch={refetch}
        refetchHasLicense={refetchHasLicense}
        setShouldRemoveRefetch={setShouldRefetch}
        onClose={() => openRemoveModal(false)}
      />
    </Panel>
  );
};

export default memo(FosterCareLicense);
